import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {reduxForm} from 'redux-form';
import * as supervisionActions from 'redux/modules/supervision';

import {Panel, Row, Col} from 'react-bootstrap';
var Datetime = require('react-datetime');
var moment = require('moment');

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import {ExportCSVForm} from 'components';

import { translate } from 'react-i18next';

import i18next from 'i18next';
import { activateMainLoading, resetSupervisionData } from '../../redux/modules/supervision';


@translate(['common'])
@connect(
  state => ({
  	groups: state.groups.data,
  	loading:state.supervision.loading,
  	user:state.auth.user,
  	currentPage:state.supervision.currentPage,
	initialValues: state.supervision.filter,
	filterOpened: state.supervision.filterOpened,
	mainLoading:state.supervision.mainLoading
  }),
  dispatch => bindActionCreators(supervisionActions, dispatch)
)
@reduxForm({
  form: 'sortForm',
  fields: ['numAscList', 'columnList', 'groupList', 
  	'addrList', 'idList', 'allFiches', 'allTime', 'causesList',
  	'perPage', 'begin_date', 'end_date', 'columnSort'],
  //destroyOnUnmount: true
})
export default class SortForm extends Component {

	
	constructor(props){
		super(props);
		this.state = { 
			filterPanelOpen: false,
			disableDate: false,
			progress: 0, // Variable d'état pour la progression
		};
		this._appliedUrlId = null; // Flag pour éviter boucle infinie
		this.toggleDisableDate = this.toggleDisableDate.bind(this)
				

	}
	componentDidMount() {
		// Restaurer les filtres depuis sessionStorage après F5
		this._restoreFiltersFromStorage();
		// Toujours appliquer l'ID de l'URL s'il existe
		this._applyUrlIdToSelect();
	}

	componentDidUpdate(prevProps) {
		// Quand on navigue depuis ProductList2, query.id change
		const currentId = this.props.query?.id;
		
		// Appliquer seulement si l'ID a changé et n'a pas déjà été appliqué
		if (currentId && currentId !== this._appliedUrlId) {
			this._applyUrlIdToSelect();
		}
	}

	_applyUrlIdToSelect() {
		const { query } = this.props;
		if (query && query.id && query.id !== 'none') {
			// Marquer comme appliqué pour éviter boucle
			this._appliedUrlId = query.id;
			
			const pid = query.pid;
			const idList = query.id.split(',').map(id => ({
				label: id,
				value: parseInt(pid, 10)
			}));
			this.props.fields.idList.onChange(idList);
		}
	}

	_restoreFiltersFromStorage() {
		try {
			const saved = sessionStorage.getItem('supervision_filters');
			if (saved) {
				const filters = JSON.parse(saved);
				console.log('SortForm: restauration filtres:', filters);
				
				// Restaurer idList seulement si il a des valeurs valides
				if (filters.idList && filters.idList.length > 0 && filters.idList[0]?.label) {
					this.props.fields.idList.onChange(filters.idList);
				}
				// Convertir les dates string ISO en objets moment
				if (filters.begin_date) {
					const beginMoment = moment(filters.begin_date);
					this.props.fields.begin_date.onChange(beginMoment);
				}
				if (filters.end_date) {
					const endMoment = moment(filters.end_date);
					this.props.fields.end_date.onChange(endMoment);
				}
				if (filters.allTime !== undefined) {
					// Pour les checkboxes, utiliser la valeur booléenne directement
					this.props.fields.allTime.onChange(!!filters.allTime);
				}
				if (filters.allFiches !== undefined) {
					this.props.fields.allFiches.onChange(!!filters.allFiches);
				}
				if (filters.causesList) {
					this.props.fields.causesList.onChange(filters.causesList);
				}
				if (filters.groupList) {
					this.props.fields.groupList.onChange(filters.groupList);
				}
				if (filters.numAscList) {
					this.props.fields.numAscList.onChange(filters.numAscList);
				}
				if (filters.addrList) {
					this.props.fields.addrList.onChange(filters.addrList);
				}
				
				// Ouvrir l'encart filtre
				if (!this.props.filterOpened) {
					this.props.openFilter();
				}
			}
		} catch (e) {
			console.error('Erreur restauration filtres:', e);
		}
	}

	_saveFiltersToStorage(values) {
		try {
			// Filtrer idList pour ne garder que les valeurs valides
			const filtersToSave = { ...values };
			if (filtersToSave.idList) {
				filtersToSave.idList = filtersToSave.idList.filter(v => v && v.label);
				if (filtersToSave.idList.length === 0) {
					delete filtersToSave.idList;
				}
			}
			sessionStorage.setItem('supervision_filters', JSON.stringify(filtersToSave));
		} catch (e) {
			console.error('Erreur sauvegarde filtres:', e);
		}
	}
	
	componentWillUnmount() {
		// Ne plus vider le filtre automatiquement
		// pour garder en mémoire les filtres entre les visites
		// this.props.resetFilterForce()
	}

	toggleDisableDate() {
		var state = {
		allFiches: !this.state.allFiches,
		disableDate:false
		}
    
    
		if( this.state.allFiches == false ) {
			state.disableDate = true;
			state['begin_date'] = false;
			state['end_date'] = false;
		}
		
		this.setState(state);

    
  	}
	
	
	
	

  render() {
  	var self = this;
    const {
		fields: {
			columnList, groupList, addrList, idList, causesList, allFiches, 
			perPage, begin_date, end_date, numAscList, columnSort, allTime, callTypesList
		},
		formKey, 
		handleSubmit, 
		invalid,
		loading,
		resetForm,
		values,
		pristine,
		groups,
		columns,
		changeFilter,
		addresses,
		currentPage,
		user, fields,
		filterOpened, t
    } = this.props;
    

    var style = {display:values.allTime ? 'none' : 'block'}
    


    return (
    	<form className="form-inline" >
	    	<div> 
	    	<Panel collapsible expanded={filterOpened}  header={<div onClick={() => this.props.openFilter()}>{t("sortForm.filters")}</div>} >
					<Row>
						{(this.props.groupList && this.props.groupList.length > 0 && !this.props.displayAnomaliesBOOL) &&

							<Col xs={6}>  
								<div className="form-group" style={{width:'100%'}}>
									<label htmlFor="groupList" className="control-label">{t("main.groups")}</label>

									<Select
											allowCreate={false}
										name="form-group-name"
										options={this.props.groupList.map((g)=>{ 
												return {"label":g.name, "value":g.id} 
											})}
											multi={true}
											{...fields['groupList']}
											onBlur={() => fields['groupList'].onBlur(fields['groupList'].value)}
										/>
									
									{/*<select className="form-control" name="groupList" multiple {...groupList}>
										{this.props.groupList.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
									</select>*/}
								
								</div>
							
							</Col>
						}
						
						{(this.props.numsAsc.length > 0 && !this.props.displayAnomaliesBOOL) &&
							
							<Col xs={6}>
							
								<div className="form-group" style={{width:'100%'}}>
						
									<label className="control-label" htmlFor="numAscList">{t("sortForm.lift_numbers")}</label>
									<Select
										allowCreate={false}
										name="form-num-asc-name" 
										options={this.props.numsAsc.filter((n)=>n!='').map((id)=>{ 																					
											return {"label":id, "value":id} 
										})} 
										multi={true}
										{...fields['numAscList']}
										onBlur={() => fields['numAscList'].onBlur(fields['numAscList'].value)}
									/>
								</div>
											
							</Col> 
						}
					
					</Row>
						
					
					
					{/*(this.props.callTypes.length > 0) &&
						<div className="form-group">
							<label className="control-label" htmlFor="callTypesList">Call Type</label>
							
							<div className="">
								<select placeholder="callTypesList" id="callTypesList"className="form-control" name="callTypesList" multiple {...callTypesList}>
								{this.props.callTypes.map(id => <option value={id}>{id}</option>)}
								</select>
							</div>
						</div>
					*/}
					
					
					
					{/* <div className="form-group">
						<label className="" >
							<input {...columnSort} ref="columnSort" type="checkbox"  id="columnSort" className="" name="columnSort" />
								&nbsp;&nbsp;Appliquer les tris des colonnes
						</label>
					</div>*/}
					
					<br/>
					
					<Panel collapsible defaultExpanded={true} header={t("sortForm.more_criterias")}>
					
						<Row>
							
							<Col xs={6}> 
								{this.props.addresses.length > 0 &&
									<div className="form-group" style={{width:'100%'}}>
										<label className="control-label" htmlFor="addrList">{t("main.addresses")}</label> 
										
										<Select
											allowCreate={false}
											name="form-addrListc-name"
											options={this.props.addresses.map((addr)=>{ 
													return {"label":addr.localisation_adresse, "value":addr.id} 
												})}
												multi={true}
												{...fields['addrList']}
												onBlur={() => fields['addrList'].onBlur(fields['addrList'].value)}
											/>
										{/*
											<select style={{width:'75%'}} id="addrList"className="form-control" name="addrList" multiple {...addrList}>
											{this.props.addresses.map(ad => <option title={ad.localisation_adresse} value={ad.id}>{ad.localisation_adresse}</option>)}
											</select>*/}
								
									</div>
								}
							</Col>
							
							
							<Col xs={6}> 
							
								{(this.props.ids.length > 0 && !this.props.displayAnomaliesBOOL) &&
									<div className="form-group" style={{width:'100%'}}>
										<label className="control-label" htmlFor="idList">{t("modeOpe.id_ptu")}</label>
										
										<Select 
											allowCreate={false}
											name="form-ids-name"
											options={this.props.ids.map((r)=>{ 
												//return {"label":r.identity, "value":[r.identity, r.mid, r.id_f, r.id_f2].filter(v=>v!='' && v).join(',')}  
												return {"label":r.identity, "value":r.pid}
											}).filter(v=>v.value !='' && v.value != 0)} 
											multi={true}
											value={(fields['idList'].value || []).filter(v => v && v.label)}
											onChange={(val) => fields['idList'].onChange(val)}
											onBlur={() => fields['idList'].onBlur(fields['idList'].value)}
										/>
									
									
										{/*<div className="">
											<select placeholder="ID" id="idList"className="form-control" name="idList" multiple {...idList}>
											{this.props.ids.map(id => <option value={id}>{id}</option>)}
											</select>
										</div>*/}
									</div>
								}
							
							</Col>
			
						
						</Row>

						<br/>

						<Row>

							<Col xs={12}>
								<div className="form-group" style={{width:'100%'}}>
									<label className="control-label" htmlFor="idList">{t("sortForm.call_reason")}</label>
									
									<Select 
										allowCreate={false}
										name="form-causesList-name"
										options={causesDict.sort(function(a, b) { return a[0] - b[0] }).map((c)=>{ 
												return {
													/*"label":t(c[0])+' '+t("sts_infos."+c[2]),
													"value":c[0]*/
													"label":t('sts_infos.'+(c[1].split(' ').join(''))),
													"value":c[0]
												}  
											})} 
											multi={true}
											{...fields['causesList']}
											onBlur={() => fields['causesList'].onBlur(fields['causesList'].value)}
									/>
								
								
								
								</div>
							</Col>
						</Row>
						
						<br/> 
						<Row>
						
							<Col xs={6}>
								<div style={{'float':'left', 'marginRight':'10px'}}>
									<b>{t("timelineEvents.start_date")} : </b>
									<Datetime style={{'width':'120px'}} 
										value={begin_date.value || this.props.initialValues?.begin_date || ''}
										locale={i18next.language}
										onChange={(date)=>begin_date.onChange(date)} ref="begin_date"
									/>
								</div>
									
							</Col>

							<Col xs={6}  >
								<div style={{'float':'left'}}> 
									<b>{t("timelineEvents.end_date")} :</b>
									<Datetime 
										value={end_date.value || this.props.initialValues?.end_date || ''}
										style={{'width':'120px'}} locale={i18next.language}
										onChange={(date)=>end_date.onChange(date)} ref="end_date" 
										disabled={this.state.disableDate}
									/>
								</div>
							</Col>
																																								
						
						</Row>
						
						
						<Row>
						
							<Col xs={12} md={12} >
								{user.role != 'user'  &&
									<div className="form-group">

										<div style={{'float':'left', width:'142px', padding:'15px 0 0 0', 'marginLeft':'0px'}}>
											<input {...allTime} ref="allTime" 
												type="checkbox"  id="allTime" className="" name="allTime" 
											/>
											<b>&nbsp; {t("sortForm.all_dates")}</b>
										</div>
										<br/>
										<label className="" >
										<input type="checkbox"  id="allFiches" className="" name="allFiches" {...allFiches} />&nbsp; {t("sortForm.display_all_sheets")}</label>

									</div>
								}
								
							</Col>
						</Row>
						
					</Panel>
					

					<div className="form-group">
				
						
						<div className="form-group">
							<div>
								<br/>
								<label className="" htmlFor="perPage">{t("sortForm.entries_per_page")} : </label>&nbsp;
								<input type="text"  id="perPage" className="form-control" name="perPage" {...perPage} />
							</div>
				
						</div>
					
						<br/>
						<br/>
							
						<button
							className="btn btn-primary"
							disabled={this.props.mainLoading}
							onClick={handleSubmit(() => {
								if (!loading) {
								var data = _.clone(values);
								var columns = data.columnSort ? this.props.columns : null;

								// Sauvegarder les filtres dans sessionStorage
								this._saveFiltersToStorage(data);

								this.props.dispatch(resetSupervisionData());
								this.props.dispatch(activateMainLoading(true));

								var executeChangeFilterBatch = function (currentPage, data, urlParams, columns, batchSize, startOffset) {
									var batchPromises = [];

									for (var i = startOffset; i < startOffset + batchSize; i++) {
										batchPromises.push(changeFilter(currentPage, data, urlParams, columns, i));
									}

									return Promise.all(batchPromises)
									.then((results) => {
										results.forEach((result) => {
										if (result && typeof result.error === 'object') {
											throw result.error;
										}
										// Faites quelque chose avec le résultat individuel ici
										});
									});
									};
									
									var self = this

								var runChangeFilterBatches = function (currentPage, data, urlParams, columns, supervisionNb, batchSize) {
									var maxOffsets = Math.ceil(supervisionNb / 5000);
									
									var completedBatches = 0; 

									if (maxOffsets > 20) {
										maxOffsets = 3
									}

									var remainingOffsets = maxOffsets;
									/*var updateProgress = function () {
										var currentProgress = ((completedBatches / maxOffsets) * 100) | 0;
										self.setState({ progress: currentProgress });
									}*/

									var executeBatch = function (offset) {
										var currentBatchSize = Math.min(batchSize, remainingOffsets)
										return executeChangeFilterBatch(currentPage, data, urlParams, columns, currentBatchSize, offset)
											.then(() => {
												remainingOffsets -= currentBatchSize;
												completedBatches++;

												if (completedBatches < maxOffsets) {
													// Pas de pause, enchaîner directement
													return executeBatch(offset + batchSize);
												} else {
													// Tous les batches sont terminés
													//updateProgress();

													self.props.dispatch(activateMainLoading(false));
													// Faites quelque chose une fois que tous les lots sont terminés
												}
											});
									};

									return executeBatch(1)
								};

								changeFilter(this.props.currentPage, data, this.props.urlParams, columns, 0)
									.then((result) => {
										const { supervisionNb } = result;
										
										// Charger 3 chunks en parallèle pour accélérer
										var batchSize = 3;

										this.props.changePage(1)

										return runChangeFilterBatches(this.props.currentPage, data, this.props.urlParams, columns, supervisionNb, batchSize);
									})
									.catch((error) => {
										console.error(error);
									});
								}
							})}
							>
							<i className={'fa ' + (this.props.mainLoading ? 'fa-cog fa-spin' : 'fa-cloud')} /> {t("sortForm.sort")}
							</button>&nbsp;
													
						<ExportCSVForm
							urlParams={this.props.urlParams} 
							filter={values} 
							columns={this.props.columns}
						/>
						&nbsp;
						
						<button type="button" className="btn btn-danger"
							onClick={() => {
								resetForm();
								this.props.resetFilter();
								// Vider le sessionStorage
								sessionStorage.removeItem('supervision_filters');
							}}
						>
							
							Reset
						</button>
							
							
					</div>
	
			
		    </Panel>
		    
	    
	    </div> 
    
    </form>
	    
    );
  }
}



var causesDict = [
	['01', "Appel usager bloqué                                                 ", "Vocal__01_"],
	['06', "Appel du technicien pour fin alarme                                 ", "Vocal__06_"],
	['07', "Appel depuis le dessus de la cabine                                 ", "Vocal__07_"],
	['08', "Appel depuis le dessous de la cabine                                ", "Vocal__08_"],
	['09', "Batterie déchargée                                                  ", "Technique__09_09"],
	['35', "Appel du technicien pour fin alarme sans vocal                      ", "Technique__35_35"],
	['10', "Batterie chargée                                                    ", "Technique__10_10"],
	['03', "Programmation du test cyclique par le technicien                    ", "Technique__03_03"],
	['04', "Test cyclique                                                       ", "Cyclique__04_"],
	['12', "Absence secteur                                                     ", "Technique__12_12"],
	['11', "Retour secteur                                                      ", "Technique__11_11"],
	['17', "Bouton alarme cabine bloqué                                         ", "Technique__17_17"],
	['18', "Bouton alarme en fonction                                           ", "Technique__18_18"],
	['19', "Présence technicien en cabine                                       ", "Vocal__19_"],
	['47', "Appel depuis le fond de la fosse                                    ", "Vocal__47_"],
	['30', "Télé-alarme en mode télé-alimentée                                  ", "Technique__30_30"],
	['31', "Télé-alarme alimentée                                               ", "Technique__31_31"],
	['36', "Appel technicien pour test appel cabine                             ", "Vocal__36_"],
	['60', "Fin intervention automatique. Ascenseur en service                  ", "Telesurveillance__60_"],
	['61', "Fin intervention pour désincarcération. Ascenseur en service        ", "Telesurveillance__61_"],
	['62', "Fin intervention pour usage anormal. Ascenseur en service           ", "Telesurveillance__62_"],
	['63', "Fin intervention pour défaillance technique. Ascenseur en service   ", "Telesurveillance__63_"],
	['64', "Fin intervention pour maintenance. Ascenseur en service             ", "Telesurveillance__64_"],
	['65', "Arrivée du technicien                                               ", "Telesurveillance__65_"],
	['68', "Début panne ascenseur via controlleur                               ", "Telesurveillance__68_"],
	['69', "Fin défaut ascenseur via controlleur                                ", "Telesurveillance__69_"],
	['70', "Fin intervention automatique. Ascenseur hors service                ", "Telesurveillance__70_"],
	['71', "Fin intervention pour désincarcération. Ascenseur hors service      ", "Telesurveillance__71_"],
	['72', "Fin intervention pour usage anormal. Ascenseur hors service         ", "Telesurveillance__72_"],
	['73', "Fin intervention pour défaillance technique. Ascenseur hors service ", "Telesurveillance__73_"],
	['74', "Fin intervention pour maintenance. Ascenseur hors service           ", "Telesurveillance__74_"],
	['16', "Appel statistique                                                   ", "Technique__16_"],
	['45', "Alarme cabine forcée                                                ", "Vocal__45_"],
	['66', "Début de panne ascenseur                                            ", "Telesurveillance__66_"],
	['67', "Fin panne ascenseur                                                 ", "Telesurveillance__67_"],
	['81', "Télésurveillance activée / Supervision désactivée                   ", "Telesurveillance__81_81"],
	['80', "Télésurveillance désactivée / Supervision désactivée                ", "Telesurveillance__80_80"],
	['75', "Depart technicien ascenseur hors service                            ", "Telesurveillance__75_"],
	['76', "Depart technicien ascenseur en service                              ", "Telesurveillance__76_"],
	['97', "Dernier appel technique sur 24hrs                                   ", "Vocal__97_97"],
	['98', "Excès d'appel dessus/dessous de cabine sur 24hrs                    ", "Vocal__98_98"],
	['40', "Fin alarme automatique                                              ", "Technique__40_40"],
	['46', "Presence technicien en cabine                                       ", "Vocal__46_"],
	['55', "Mise sous tension                                                   ", "Telesurveillance_71_55_55"],
	['56', "Batterie absente ou HS                                              ", "Technique__56_56"],
	['57', "Autonomie suffisante                                                ", "Technique__57_57"],
	['58', "Autonomie inférieure à 1 heure                                      ", "Technique__58_58"],
	['59', "Batterie défectueuse                                                ", "Technique__59_59"],
	['77', "Début de travaux                                                    ", "Telesurveillance__77_"],
	['78', "Fin de travaux                                                      ", "Telesurveillance__78_"],
	['79', "Retour ligne telephonique                                           ", "Technique__94_94"],
	['82', "Télésurveillance désactivée / Supervision activée                   ", "Telesurveillance__82_82" ],
	['83', "Télésurveillance activée / Supervision activée                      ", "Telesurveillance__83_83"],
	['86', "1ere Mise en service télésurveillance                               ", "Telesurveillance__86_"],
	['87', "Identité différente entre le serveur et le site                     ", "Telesurveillance__87_"],
	['88', "Retour liaison PTU - GSM, ascenseur en service                      ", "Telesurveillance__88_"],
	['89', "Retour liaison PTU - GSM, ascenseur hors service                    ", "Telesurveillance__89_"],
	['91', "Absence boitier technicien                                          ", "Technique__91_91"],
	['92', "Retour boitier technicien                                           ", "Technique__92_92"],
	['93', "Absence module relais MD03                                          ", "Technique__93_93"],
	['94', "Retour module relais MD03                                           ", "Technique__94_94"],
	['84', "Service FTP désactivé                                               ", "Telesurveillance__84_"],
	['85', "Service FTP activé                                                  ", "Telesurveillance__85_"],
	['96', "Dernier appel défaut ascenseur sur 24hrs                            ", "Telesurveillance__96_"],
	['66', "Début de panne escalier mécanique                                   ", "Telesurveillance_30_66_"],
	['67', "Fin de panne escalier mecanique                                     ", "Telesurveillance_30_67_"],
	['93', "Absence capteur escalier mécanique                                  ", "Technique_30_93_"],
	['94', "Retour capteur escalier mécanique                                   ", "Technique_30_94_"],
	['TF', "Absence trafic                                                      ", "Serveur__TF_"],
	['FT', "Retour trafic                                                       ", "Serveur__FT_"],
	['CK', "Test cyclique non reçu au bout de 4 jours.                          ", "Serveur__CK_"],
	['CO', "Test cyclique reçu.                                                 ", "Serveur__CO_"],
	['CN', "Test cyclique non acquitté par la centrale.                         ", "Serveur__CN_"],
	['D0', "Début défaut carte STS 1                                            ", "Telesurveillance_30_D0_"],
	['D1', "Fin défaut carte STS 1                                              ", "Telesurveillance_30_D1_"],
	['D2', "Début défaut carte STS 2                                            ", "Telesurveillance_30_D2_"],
	['D3', "Fin défaut carte STS 2                                              ", "Telesurveillance_30_D3_"],
	['A0', "Début révision                                                      ", "Telesurveillance_30_A0_"],
	['A2', "Début défaillance                                                   ", "Telesurveillance_30_A2_" ],
	['A4', "Début défaut stop supérieur                                         ", "Telesurveillance_30_A4_"],
	['A6', "Début défaut stop inférieur                                         ", "Telesurveillance_30_A6_"],
	['A8', "Début défaut peigne supérieur                                       ", "Telesurveillance_30_A8_"],
	['AA', "Début défaut peigne inférieur                                       ", "Telesurveillance_30_AA_"],
	['B0', "Début défaut marche                                                 ", "Telesurveillance_30_B0_"],
	['B2', "Début défaut ouverture fosse supérieure                             ", "Telesurveillance_30_B2_"],
	['B4', "Début défaut ouverture fosse inférieure                             ", "Telesurveillance_30_B4_"],
	['B6', "Début hors service                                                  ", "Telesurveillance_30_B6_"],
	['B8', "Début arrêt avec clé                                                ", "Telesurveillance_30_B8_"],
	['BA', "Début défaut niveau d'eau                                           ", "Telesurveillance_30_BA_"],
	['A1', "Fin révision                                                        ", "Telesurveillance_30_A1_"],
	['A3', "Fin défaillance                                                     ", "Telesurveillance_30_A3_"],
	['A5', "Fin stop supérieur                                                  ", "Telesurveillance_30_A5_"],
	['A7', "Fin stop inférieur                                                  ", "Telesurveillance_30_A7_"],
	['A9', "Fin défaut peigne supérieur                                         ", "Telesurveillance_30_A9_"],
	['AB', "Fin défaut peigne inférieur                                         ", "Telesurveillance_30_AB_"],
	['B1', "Fin défaut marche                                                   ", "Telesurveillance_30_B1_"],
	['B3', "Fin défaut ouverture fosse supérieure                               ", "Telesurveillance_30_B3_"],
	['B5', "Fin défaut ouverture fosse inférieure                               ", "Telesurveillance_30_B5_"],
	['B7', "Fin hors service                                                    ", "Telesurveillance_30_B7_"],
	['B9', "Fin arrêt avec clé                                                  ", "Telesurveillance_30_B9_"],
	['BB', "Fin défaut niveau d'eau                                             ", "Telesurveillance_30_BB_"]].sort(function(a, b) { 
		return a[1] > b[1] ? 1 : -1;
	});